// extracted by mini-css-extract-plugin
module.exports = {"Container":"EmailVerification_Container__rZ9A0","Animation":"EmailVerification_Animation__ZV89L"};